module.exports = __webpack_public_path__ + "static/15-98c572345abe75fd08e7b2713b017c29.png";